// DynamicContentDecorator.ts
import { Extension } from '@tiptap/core'
import { Plugin, PluginKey } from '@tiptap/pm/state'
import { Decoration, DecorationSet } from '@tiptap/pm/view'

const DYNAMIC_CONTENT_REGEX = /\{\{\s*dynamicContent\.[a-zA-Z0-9_]+\s*\}\}/g

export const DynamicContentDecorator = Extension.create({
  name: 'dynamicContentDecorator',

  addProseMirrorPlugins() {
    const getDecorations = doc => {
      const decorations: Decoration[] = []

      doc.descendants((node, pos) => {
        if (!node.isText) return

        let match
        while ((match = DYNAMIC_CONTENT_REGEX.exec(node.text || '')) !== null) {
          const start = pos + match.index
          const end = start + match[0].length

          decorations.push(
            Decoration.inline(start, end, {
              class: 'dynamic-content',
              nodeName: 'span',
              style: 'background:#eef; color:#336; white-space:nowrap; display: inline-block; padding: 1px 3px; border-radius: 5px; pointer-events: none;',
            })
          )
        }
      })

      return DecorationSet.create(doc, decorations)
    }

    return [
      new Plugin({
        key: new PluginKey('dynamicContentDecorator'),

        state: {
          init: (_, { doc }) => getDecorations(doc),
          apply: (transaction, oldDecorationSet, _, newState) =>
            transaction.docChanged ? getDecorations(newState.doc) : oldDecorationSet,
        },

        props: {
          decorations: state => getDecorations(state.doc),
        },
      }),
    ]
  },
})